import type { MouseEvent } from "react";
import { WORLD_NAME, labHref } from "./types";
import { DawnPoster } from "./worlds/dawn";
import { LampPoster } from "./worlds/lamp";
import { PocketPoster } from "./worlds/pocket";

export function Chooser({
  basePath,
  onTraverse,
}: {
  basePath: string;
  onTraverse?: (href: string, event: MouseEvent<HTMLAnchorElement>) => void;
}) {
  return (
    <div data-lab-chooser="">
      <header className="lab-chooser-head">
        <h1>Какой мир подходит Clever?</h1>
        <p>Откройте любой — вернуться можно в один клик.</p>
      </header>
      <div className="lab-posters">
        <div className="lab-poster-slot">
          <p className="lab-poster-name">{WORLD_NAME.dawn}</p>
          <DawnPoster href={labHref(basePath, "dawn", "landing")} onTraverse={onTraverse} />
        </div>
        <div className="lab-poster-slot is-chosen">
          <p className="lab-poster-name">
            {WORLD_NAME.pocket}
            <span className="lab-poster-pick">Выбран</span>
          </p>
          <PocketPoster href={labHref(basePath, "pocket", "landing")} onTraverse={onTraverse} />
        </div>
        <div className="lab-poster-slot">
          <p className="lab-poster-name">{WORLD_NAME.lamp}</p>
          <LampPoster href={labHref(basePath, "lamp", "landing")} onTraverse={onTraverse} />
        </div>
      </div>
    </div>
  );
}
